import { render } from "./ContactUs.vue?vue&type=template&id=88104f8c&scoped=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=88104f8c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-88104f8c"

export default script